module.exports = __webpack_public_path__ + "81341e3c7f56e63ffd5d33c4a50c875a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/2.jpg
// module id = ./src/components/Carousel/images/2.jpg
// module chunks = 0